// extracted by mini-css-extract-plugin
module.exports = {"customInputContainer":"style_customInputContainer__3Mg6v","label":"style_label__35n25"};